export default "__VITE_ASSET__HODN$8zU__"